



























































import {
  defineComponent, reactive, ref, watch, computed,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import gql from 'graphql-tag';

import updateOwnUser from '@/gql/updateOwnUser.gql';

const Setting = defineComponent({
  setup() {
    const form = reactive({
      firstName: '',
      lastName: '',
      employeeCode: '',
      username: '',
      password: '',
      confirmPassword: '',
    });

    const editPassword = ref(false);

    const { result: myInfo, onResult } = useQuery(gql`
      query getMyInfo {
        me {
          id
          firstName
          lastName
          employeeCode
          roles {
            id
            name
          }
        }
      }
    `, {}, {
      fetchPolicy: 'network-only',
    });
    watch(myInfo, () => {
      const media = useResult(myInfo, null, (data) => data.me);
      const item = media.value;
      form.firstName = item?.firstName;
      form.lastName = item?.lastName;
      form.employeeCode = item?.employeeCode || '';
      form.username = item?.username;
    });

    const updateOwnUserVariables = computed(() => ({
      firstName: form.firstName || '',
      lastName: form.lastName || '',
      employeeCode: form.employeeCode || '',
      username: form.username,
      password: editPassword.value ? form.password : null,
    }));

    const updateOwnUserMuation = useMutation(
      updateOwnUser,
      () => ({
        variables: { ...updateOwnUserVariables.value },
        refetchQueries: ['getUsers'],
      }),
    );

    return {
      form,
      editPassword,
      updateOwnUserMuation,
    };
  },
});

export default Setting;
